import { render, staticRenderFns } from "./articleForm.vue?vue&type=template&id=a5713132"
import script from "./articleForm.vue?vue&type=script&lang=js"
export * from "./articleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports